import { FC } from "react";

import { Grid, MenuItem, TextField } from "@mui/material";

import { FeedbackFilters } from "@/components/feedback/types";

export interface FeedbackFilterFieldsProps {
  filters: FeedbackFilters;
  onFiltersChange: (next: FeedbackFilters) => void;
  surveyOptions: { id: string; name: string }[];
}

const FeedbackFilterFields: FC<FeedbackFilterFieldsProps> = ({
  filters,
  onFiltersChange,
  surveyOptions,
}) => {
  const update = <K extends keyof FeedbackFilters>(
    key: K,
    value: FeedbackFilters[K],
  ) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <TextField
          select
          label="Survey Name"
          value={filters.collectionId ?? ""}
          onChange={(e) => update("collectionId", e.target.value || null)}
          size="small"
          fullWidth
          slotProps={{ inputLabel: { shrink: true } }}
        >
          <MenuItem value="">Any</MenuItem>
          {surveyOptions.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
              {opt.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Submitted Start Date"
          type="date"
          value={
            filters.submitStartDate
              ? new Date(filters.submitStartDate).toISOString().split("T")[0]
              : ""
          }
          onChange={(e) =>
            update(
              "submitStartDate",
              e.target.value ? new Date(e.target.value).toISOString() : null,
            )
          }
          size="small"
          fullWidth
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          label="Submitted End Date"
          type="date"
          value={
            filters.submitEndDate
              ? new Date(filters.submitEndDate).toISOString().split("T")[0]
              : ""
          }
          onChange={(e) =>
            update(
              "submitEndDate",
              e.target.value ? new Date(e.target.value).toISOString() : null,
            )
          }
          size="small"
          fullWidth
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Grid>
    </Grid>
  );
};

export default FeedbackFilterFields;
